<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendTeacher',
          query: {
            title: $route.query.title,
            recommend: $route.query.recommend,
          },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">
        {{ teacher.teacher_name || teacher.real_name }}
      </span>
    </div>
    <div class="bread" v-else>
      <router-link v-if="lastRoute.name" :to="{ name: lastRoute.name }">
        {{ lastRoute.label }}
      </router-link>
      <span v-else>一对一</span>
      <span class="slash">/</span>
      <span class="current">
        {{ teacher.teacher_name || teacher.real_name }}
      </span>
    </div>
    <div class="teacher-intro">
      <div class="clear intro-box">
        <div class="avatar f-left">
          <img :src="teacher.photo" />
          <p v-if="!isNormal">约课</p>
        </div>
        <div class="f-left main" :class="isNormal ? 'normal' : ''">
          <div v-if="!isNormal" class="is-normal">
            <div class="title-tag">
              <span class="title">{{ teacher.teacher_name }}</span>
              <span class="t-tag">{{ teacher.level_name }}</span>
            </div>
            <p class="li-title">{{ teacher.marketing_language }}</p>
            <div class="small-tag">
              <p v-if="teacher.sex == 0" class="tea-attr1">男</p>
              <p v-else class="tea-attr2">女</p>
              <p class="tea-attr3">{{ teacher.age }}岁</p>
              <p class="tea-attr4">{{ teacher.teach_age }}年教龄</p>
            </div>
            <!-- <div class="small">{{teacher.sex==0?'男':'女'}}，{{teacher.age}}岁，{{teacher.teach_age}}年教龄</div> -->
          </div>
          <div v-else class="not-normal">
            <span class="title">{{ teacher.real_name }}</span>
            <p class="li-title">{{ teacher.marketing_language }}</p>
            <ul class="set-attribute">
              <li v-for="(attr, index) in attrs" :key="index">
                <span>{{ attr.attr_name }}：</span>
                {{ attr.attr_value_names }}
              </li>
            </ul>
            <div class="line"></div>
          </div>
          <div class="li-desc" v-html="intro"></div>
          <p v-if="!isNormal" class="li-price">
            <span class="text">约课收费</span>
            <CurrencyNew
              :price="teacher.section_price"
              :priceTwo="true"
            ></CurrencyNew>
            <span class="unit">／课时</span>
          </p>
        </div>
        <template v-if="false">
          <span class="f-right collect" v-if="flag == 1" @click="cancelCollect">
            已收藏
          </span>
          <span class="f-right collect" v-else @click="collect">收藏</span>
        </template>
      </div>
      <div v-if="teacher.tag_content" class="clear">
        <div
          class="tag f-left"
          v-for="(tag, index) in teacher.tag_content"
          :key="index"
        >
          {{ tag }}
        </div>
      </div>
    </div>
    <div class="teacher-main">
      <BlockTabs
        class="block-tabs"
        :items="tabs"
        currentClass="bold5"
        @changeTab="changeTab"
      ></BlockTabs>
      <div class="tab-content" :class="'tab-content-' + tab.toString()">
        <div v-show="tab == 0">
          <div class="intro-item" v-for="(attr, index) in attrs" :key="index">
            <label>{{ attr.attr_name }}：</label>
            <span>{{ attr.attr_value_names }}</span>
          </div>
          <div class="intro-item">
            <label>老师介绍：</label>
            <span v-html="intro"></span>
          </div>
        </div>
        <div v-show="tab == 1">
          <ul class="sort clearfix">
            <li :class="{ active: sort == 0 }" @click="changeSort(0)">综合</li>
            <li :class="{ active: sort == 1 }" @click="changeSort(1)">最新</li>
            <li :class="{ active: sort == 2 }" @click="changeSort(2)">最热</li>
            <li
              class="sort-price"
              :class="{
                active: sort == 3 || sort == 4,
                desc: sort == 4,
                asc: sort == 3,
              }"
              @click="changeSort(sort == 4 ? 3 : 4)"
            >
              价格
            </li>
          </ul>
          <List
            class="list"
            ref="list"
            url="/api/app/teacher/mainCourse"
            :search="params"
            :limit="15"
            :alwaysShowPager="true"
            method="post"
          >
            <template v-slot="{ list }">
              <div class="course-list clearfix">
                <RichCourseItem
                  v-for="course in list"
                  :key="course.id"
                  :course="course"
                  :withRecommend="false"
                ></RichCourseItem>
              </div>
              <Empty v-if="list.length == 0" title="暂无课程安排，敬请期待" />
            </template>
          </List>
        </div>
        <div v-if="tab == 2" class="schedule">
          <el-tabs v-model="is_next">
            <el-tab-pane
              v-for="(value, key) in weekTab"
              :key="key"
              :label="value"
              :name="key"
            >
              <OtoScheduleTable
                :teacherId="$route.params.id.toString()"
                :is_next="is_next"
              ></OtoScheduleTable>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="tab == 3">
          <div class="clear comment" v-if="false">
            <div class="tag" v-for="tag in tags" :key="tag.id">
              {{ tag.title }}（{{ tag.count }}）
            </div>
          </div>
          <div class="appraise">
            <div
              class="item clearfix"
              v-for="appraise in appraiseList"
              :key="appraise.id"
            >
              <img class="avatar" :src="appraise.avatar" />
              <div class="f-left right">
                <div class="clearfix">
                  <span class="user f-left">
                    {{ appraise.user_name + " 评价" }}
                  </span>
                  <span class="primary-color f-left">
                    {{ appraise.course_time }}
                  </span>
                  <span class="yue f-left">的约课</span>
                  <div class="f-left" style="position: relative">
                    <el-rate v-model="appraise.grade" class="f-left"></el-rate>
                    <div class="mask"></div>
                  </div>
                  <a
                    class="operate delete"
                    v-if="$store.state.user_info.id == appraise.uid"
                    @click="onCommentDelete(appraise)"
                  >
                    删除
                  </a>
                  <a
                    class="operate complaint"
                    v-else
                    @click="onComplaint(appraise)"
                  >
                    举报
                  </a>
                </div>
                <div class="clear tags">
                  <div class="tag" v-for="tag in appraise.tags" :key="tag">
                    {{ tag }}
                  </div>
                </div>
                <div class="content">{{ appraise.content }}</div>
                <div class="time">{{ appraise.created_at | tsFormatLong }}</div>
              </div>
            </div>
            <el-pagination
              background
              @current-change="handleAppraiseChange"
              :current-page="pageAppraise"
              :page-size="limitAppraise"
              layout="prev, pager, next, total, jumper"
              :total="totalAppraise"
              v-if="appraiseList.length > 0"
            ></el-pagination>
          </div>
          <Empty v-if="appraiseList.length == 0" title="暂无讲师评价信息哦！" />
        </div>
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>
<script>
import RichCourseItem from "../../components/rich/CourseItem.vue";
import OtoScheduleTable from "../../components/OtoScheduleTable.vue";
import Complaint from "../../components/Complaint.vue";
import List from "@/components/List.vue";

export default {
  name: "LecturerShow",
  components: {
    OtoScheduleTable,
    RichCourseItem,
    Complaint,
    List,
  },
  computed: {
    tabs() {
      let tabs = [];
      // tabs.push({ id: 0, name: "讲师简介" });
      tabs.push({ id: 1, name: "主讲课程" });
      if (
        !this.isNormal &&
        this.$store.state.commonSetting.switch_oto_module == 1
      ) {
        tabs.push({ id: 2, name: "约课课表" });
        tabs.push({ id: 3, name: "讲师评价" });
      }
      return tabs;
    },
    commonSetting() {
      return this.$store.state.commonSetting;
    },
  },
  data() {
    return {
      id: "",
      teacher: {},
      isNormal: true,
      flag: 2,
      tab: 1,
      attrs: [],
      intro: "",
      courses: [],
      pageAppraise: 1,
      limitAppraise: 10,
      totalAppraise: 0,
      tags: [],
      appraiseList: [],
      lastRoute: {
        name: this.$route.query.route_name || "Oto",
        label: this.$route.query.route_label || "一对一",
      },
      is_next: 0,
      weekTab: {
        0: "本周课表",
        1: "下周课表",
      },
      sort: 0,
      params: {
        teacher_id: "",
        order_by: 0,
      },
    };
  },
  async created() {
    this.id = this.$route.params.id;
    this.params.teacher_id = this.$route.params.id;
    let data = await this.$http.get("/api/app/teacher/" + this.id);

    this.teacher = data.teacher;
    this.isNormal = !!data.teacher.real_name;
    this.flag = data.flag;

    let dataAttr = await this.$http.get("/api/app/teacher/info/" + this.id);
    if(dataAttr.attr&&dataAttr.attr.length>0)
    {
      dataAttr.attr.forEach(a => {
      let attr_value_names = [];
      a.attr_value.forEach(av => {
        attr_value_names.push(av.attr_value_name);
      });
      a.attr_value_names = attr_value_names.join(",");
    });
    this.attrs = dataAttr.attr;
    }
    else
    {
      this.attrs = [];
    }
    this.intro = (dataAttr.intro || "").replace(/\n/g, "<br/>");

    if (this.isNormal) {
      return;
    }
    await this.getAppraise();
  },
  methods: {
    async collect() {
      await this.$http.get("/api/app/teacher/collect/" + this.id, {}, true);
      this.$message({
        message: "收藏成功",
        type: "success",
      });
      this.flag = 1;
    },
    async cancelCollect() {
      await this.$http.get("/api/app/teacher/collect/" + this.id);
      this.$message({
        message: "取消收藏成功",
        type: "success",
      });
      this.flag = 2;
    },
    changeTab(item) {
      this.tab = item.id;
    },
    async getAppraise() {
      let data = await this.$http.post(
        "/api/app/teacher/comment?teacher_id=" + this.id,
        {
          page: this.pageAppraise,
          limit: this.limitAppraise,
        },
      );
      let tags = data.tag;
      tags = tags.sort((a, b) => b.count - a.count);
      this.tags = tags;
      this.totalAppraise = data.comment.total;
      let appraiseList = data.comment.list;
      appraiseList.forEach(a => {
        let times = a.course_time.split(" ");
        times[0] = times[0].replace(/-/g, "/");
        a.course_time = times.join(" ");
        if (!a.tag_content) {
          return;
        }
        a.tags = a.tag_content.split(",");
      });
      this.appraiseList = appraiseList;
    },
    async handleAppraiseChange(page) {
      this.pageAppraise = page;
      await this.getAppraise();
    },
    async onCommentDelete(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
      });
      await this.$http.delete("/api/app/oto/comment/" + item.id);
      await this.getAppraise();
    },
    onComplaint(item) {
      this.$refs.complaint.show(2, item.id);
    },
    changeSort(sort) {
      this.sort = sort;
      this.params.order_by = sort;
      this.$refs.list.searchRefresh();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/oto-teacher.scss";
</style>
